export default __webpack_public_path__ + "static/media/bm.3c64a9b6.svg";